import { Box } from '@material-ui/core'

import { Header } from '@/pages/diagnosis-view/components/header'

import { BufferLayers } from './buffer-layers'
import { EquipmentDefinition } from './equipment-definition'
import { HerbicideTreatments } from './herbicide-treatments'
import { MergeLayers } from './merge-layers'
import { PulverizationSummary } from './pulverization-summary'
import { SelectLayers } from './select-layers'
import { StepperMenu } from './stepper-menu'

const stepComponents = [
  SelectLayers,
  MergeLayers,
  BufferLayers,
  HerbicideTreatments,
  EquipmentDefinition,
  PulverizationSummary,
]

interface CreatePulverizationMapStepperProps {
  activeStep: number
  goBack: () => void
}

export function CreatePulverizationMapStepper({
  activeStep,
  goBack,
}: CreatePulverizationMapStepperProps) {
  const CurrentStepComponent = stepComponents[activeStep - 1]

  return (
    <>
      <Header title='Criar mapa de pulverização' goBack={goBack} />

      <Box flex={1} display='flex' flexDirection='column' gridGap='0.64rem'>
        <StepperMenu />
        <CurrentStepComponent />
      </Box>
    </>
  )
}
